import { render, staticRenderFns } from "./assistantManager.vue?vue&type=template&id=64ef6144&scoped=true"
import script from "./assistantManager.vue?vue&type=script&lang=js"
export * from "./assistantManager.vue?vue&type=script&lang=js"
import style0 from "./assistantManager.vue?vue&type=style&index=0&id=64ef6144&prod&lang=scss&scoped=true"
import style1 from "./assistantManager.vue?vue&type=style&index=1&id=64ef6144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef6144",
  null
  
)

export default component.exports